import { r as registerInstance, c as createEvent, h } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a as vString, J as vNumber, b as vMinLength, S as vOneOf, $ as vNullOr, Q as vBoolean } from './validation-02b8d01d.js';
import { c as currentLocale, t } from './i18n-939e2dee.js';
import { l as langs, r as returnTypes, c as countries } from './countries-358acdc0.js';
import './types-6f6b2fba.js';

const DsSelectCountry = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.propError = {};
    this.currentLang = 'en';
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.label = '';
    this.returnType = 'numeric';
    this.value = null;
    this.isDisabled = false;
    this.isReadonly = false;
    this.isRequired = false;
    this.isFloatLabel = false;
    this.isMini = false;
  }
  updateLocale() {
    this.currentLocale = currentLocale();
    const lng = this.currentLocale.substring(0, 2).toLowerCase();
    if (langs.includes(lng))
      this.currentLang = lng;
    else
      this.currentLang = 'en';
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vString))
      return;
  }
  watchReturnType(_, prevReturnType) {
    /* istanbul ignore if */
    if (!propCheck(this, 'returnType', returnTypes.join(' | '), vOneOf(returnTypes)))
      return;
    if (this.value && prevReturnType) {
      const currentCountry = countries.find(c => c[prevReturnType] === this.value);
      this.dsInput.emit(currentCountry[this.returnType]);
    }
  }
  watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'string | number | null', vNullOr(v => vString(v) && vNumber(v))))
      return;
  }
  async watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
  }
  async watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
  }
  async watchIsRequired() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isRequired', 'boolean', vBoolean))
      return;
  }
  watchIsFloatLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isFloatLabel', 'boolean', vBoolean))
      return;
  }
  watchIsMini() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isMini', 'boolean', vBoolean))
      return;
  }
  async injectError(error) {
    this.dsSelect.injectError(error);
  }
  async hideError() {
    this.dsSelect.hideError();
  }
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h("ds-select-simple", { ref: el => this.dsSelect = el, name: this.name, label: this.label, isReadonly: this.isReadonly, isDisabled: this.isDisabled, value: this.value, onDsInput: e => {
        e.stopPropagation();
        e.preventDefault();
        this.dsInput.emit(e.detail);
      }, isFloatLabel: this.isFloatLabel, isSearchable: true, isScrollable: true, isMini: this.isMini, validate: this.isRequired ? (v => vString(v) && vNumber(v) ? t('validation.required') : undefined) : undefined, options: countries.map(country => ({ label: country.name[this.currentLang], value: country[this.returnType] })).sort((a, b) => a.label.localeCompare(b.label)) }));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "label": ["watchLabel"],
    "returnType": ["watchReturnType"],
    "value": ["watchValue"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isRequired": ["watchIsRequired"],
    "isFloatLabel": ["watchIsFloatLabel"],
    "isMini": ["watchIsMini"]
  }; }
};

export { DsSelectCountry as ds_select_country };
